import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';
import api from '@services/api';

const DEFAULT_ERROR_MESSAGE = 'Erro ao iniciar atendimento. Tente novamente!';

type Props = {
  executionId: string,
  afterSubmit?: () => void,
};

const useStartExecution = ({ executionId, afterSubmit }:Props) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const nextExecution = async () => {
    try {
      setLoading(true);
      const response = await api.post(`/campaign_execution/${executionId}/next`);
      if (response.status === 200) {
        afterSubmit?.();
        navigate(`/painel/atendimentos/${executionId}/cliente`, {
          state: {
            customer: response.data.customer,
            dispositionId: response.data.id,
          },
        });
        toast.success('Atendimento iniciado com sucesso!');
        window.scrollTo(0, 0);
      } else {
        toast.error(DEFAULT_ERROR_MESSAGE);
      }
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const onStartExecution = async () => {
    try {
      const response = await api.post(`/campaign_execution/${executionId}/current`);

      if (response.status === 200) {
        afterSubmit?.();
        navigate(`/painel/atendimentos/${executionId}/cliente`, {
          state: {
            customer: response.data.customer,
            dispositionId: response.data.id,
          },
        });
        toast.success('Atendimento iniciado com sucesso!');
        window.scrollTo(0, 0);
      } else {
        await nextExecution();
      }
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  return { onStartExecution, loading };
};

export default useStartExecution;
